export default __webpack_public_path__ + "static/media/35_ACHB.0c2afe1d.png";